import {
  Box,
  ClickAwayListener,
  Tooltip,
  TooltipProps,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactNode, useState } from 'react';

const boxStyles = {
  width: 'fit-content',
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  textDecoration: 'underline',
  textDecorationStyle: 'dashed',
  textUnderlineOffset: '4px',
  textDecorationColor: 'gray',
};

const ShowTooltipText = ({
  placement = 'top',
  children,
  tooltipContent,
}: {
  placement?: TooltipProps['placement'];
  children: ReactNode;
  tooltipContent: string;
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = (e: any) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <Box>
      {!matches ? (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            arrow
            placement={placement}
            componentsProps={{
              tooltip: {
                sx: {
                  borderRadius: '8px',
                },
              },
            }}
            PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -10], // Adjust the second value to reduce/increase spacing
                  },
                },
              ],
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={tooltipContent}
          >
            <Box
              sx={boxStyles}
              onClick={handleTooltipOpen}
            >
              {children}
            </Box>
          </Tooltip>
        </ClickAwayListener>
      ) : (
        <Tooltip
          arrow
          placement={placement}
          disableFocusListener
          title={tooltipContent}
          componentsProps={{
            tooltip: {
              sx: {
                borderRadius: '8px',
              },
            },
          }}
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -10], // Adjust the second value to reduce/increase and spacing
                },
              },
            ],
          }}
        >
          <Box sx={boxStyles}>{children}</Box>
        </Tooltip>
      )}
    </Box>
  );
};

export default ShowTooltipText;
